export const MEASUREMENTS = {
    EnrollInExternalCourse: 1733,
    CreateAccountWithEmail: 1735,
    CreateAccountWithItslearningLogin: 1736,
    LoginAsRecurringUser: 1737
};